import * as React from 'react';
import { IGeneralDentalReferral } from '../../../../models/IGeneralDentalReferral';
import { GeneralDentalReferralFileSection } from './GeneralDentalReferralFileSection';

interface IGeneralDentalReferralOtherInformation {
    generalDentalReferral: IGeneralDentalReferral;
    isFetchingGeneralDentalReferral: boolean;
}

export const GeneralDentalReferralOtherInformation: React.FunctionComponent<IGeneralDentalReferralOtherInformation> = ({ generalDentalReferral, isFetchingGeneralDentalReferral }) => {

    return (
        <>
            <div className={`row ${generalDentalReferral.canEdit ? "" : "readonly-less-margin"}`}>
                <h5 className="col-12">Annat</h5>
                {
                    !isFetchingGeneralDentalReferral ?
                        <GeneralDentalReferralFileSection generalDentalReferral={generalDentalReferral} />
                        : null
                }
            </div>
        </>
    )
}